<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <div slot="header">
            <strong>Thêm mới ảnh vào trình chiếu</strong>
          </div>
          <b-form @submit.prevent="save">
            <b-row>
              <b-col>
                <b-form-group
                  label="Kiểu:"
                  label-for="sliderTypes"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                >
                  <select2
                    class="no-padding col-10"
                    v-model="slider.sliderType"
                    v-if="sliderTypes.length > 0"
                    :options="sliderTypes"
                    placeholder="--- Chọn ---"
                  ></select2>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row >
              <b-col>
                <b-form-group
                  label="Hình ảnh:"
                  label-for="file"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                >
                  <b-form-file
                    v-model="$v.slider.file.$model"
                    id="file"
                    class="col-10 no-padding"
                    accept="image/*"
                    browse-text="Chọn"
                    :state="
                      $v.slider.file.$dirty ? !$v.slider.file.$error : null
                    "
                    placeholder="Chọn tệp tải lên..."
                  >
                  </b-form-file>
                  <b-form-invalid-feedback>
                    Trường này không được để trống!
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="!isImage">
              <b-col>
                <b-form-group
                  label="Danh mục slider:"
                  label-for="sliderVideoTypes"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                >
                  <select2
                    class="no-padding col-10"
                    v-model="slider.sliderVideoTypeId"
                    v-if="sliderVideoTypes.length > 0"
                    :options="sliderVideoTypes"
                    placeholder="--- Chọn ---"
                  ></select2>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="isImage">
              <b-col>
                <b-form-group
                  label="Tiêu đề:"
                  label-for="title"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                  label-class="required"
                >
                  <b-form-input
                    type="text"
                    id="title"
                    class="col-10"
                    v-model="$v.slider.title.$model"
                    :state="
                      $v.slider.title.$dirty ? !$v.slider.title.$error : null
                    "
                  >
                  </b-form-input>
                  <b-form-invalid-feedback>
                    Trường này không được để trống!
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="isImage">
              <b-col>
                <b-form-group
                  label="Mô tả:"
                  label-for="description"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                  label-class="required"
                >
                  <b-form-textarea
                    v-model="$v.slider.description.$model"
                    :state="
                      $v.slider.description.$dirty
                        ? !$v.slider.description.$error
                        : null
                    "
                    class="col-10"
                    id="description"
                    rows="3"
                  ></b-form-textarea>
                  <b-form-invalid-feedback>
                    Trường này không được để trống!
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="isImage">
              <b-col>
                <b-form-group
                  label="Đường dẫn:"
                  label-for="link"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                  label-class="required"
                >
                  <b-form-input
                    type="text"
                    id="link"
                    class="col-10"
                    v-model="$v.slider.link.$model"
                    :state="
                      $v.slider.link.$dirty ? !$v.slider.link.$error : null
                    "
                  >
                  </b-form-input>
                  <b-form-invalid-feedback>
                    Trường này không được để trống!
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="!isImage">
              <b-col>
                <b-form-group
                  label="Đường dẫn:"
                  label-for="urlImage"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                  label-class="required"
                >
                  <b-form-input
                    type="text"
                    id="urlImage"
                    class="col-10"
                    v-model="$v.slider.urlImage.$model"
                    :state="
                      $v.slider.urlImage.$dirty
                        ? !$v.slider.urlImage.$error
                        : null
                    "
                  >
                  </b-form-input>
                  <b-form-invalid-feedback>
                    Trường này không được để trống!
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="isImage">
              <b-col>
                <b-form-group
                  label="Nhãn nút ấn:"
                  label-for="labelButton"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                  label-class="required"
                >
                  <b-form-input
                    type="text"
                    id="labelButton"
                    class="col-10"
                    v-model="$v.slider.labelButton.$model"
                    :state="
                      $v.slider.labelButton.$dirty
                        ? !$v.slider.labelButton.$error
                        : null
                    "
                  >
                  </b-form-input>
                  <b-form-invalid-feedback>
                    Trường này không được để trống!
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Số thứ tự hiển thị:"
                  label-align="right"
                  label-for="description"
                  :label-cols="2"
                  :horizontal="true"
                >
                  <b-form-input
                    type="number"
                    class="col-10"
                    v-model="slider.displayOrder"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group :label-cols="2" :horizontal="true">
                  <b-button
                    v-if="authorize(['ManageSlider'])"
                    type="submit"
                    variant="primary"
                    >Ghi lại</b-button
                  >
                  <b-button type="button" variant="secondary" @click="cancel">
                    Hủy</b-button
                  >
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import { authorizationMixin } from "@/shared/mixins";
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import { requiredIf } from "vuelidate/lib/validators";

export default {
  name: "CreateSlider",
  mixins: [validationMixin, authorizationMixin],
  data() {
    return {
      slider: {
        id: 0,
        urlImage: null,
        title: null,
        description: null,
        link: null,
        labelButton: null,
        displayOrder: null,
        file: null,
        sliderType: "1",
        sliderVideoTypeId: null,
      },
      sliderTypes: [
        { id: 1, text: "Hình ảnh" },
        { id: 2, text: "Video" },
      ],
    };
  },
  validations: {
    slider: {
      title: {
        requiredIf() {
          return !(this.isImage && !this.slider.title);
        },
      },
      description: {
        requiredIf() {
          return !(this.isImage && !this.slider.description);
        },
      },
      link: {
        requiredIf() {
          return !(this.isImage && !this.slider.link);
        },
      },
      labelButton: {
        requiredIf() {
          return !(this.isImage && !this.slider.labelButton);
        },
      },
      file: {
        requiredIf() {
          return !(this.isImage && !this.slider.file);
        },
      },
      urlImage: {
        requiredIf() {
          return !(!this.isImage && !this.slider.urlImage);
        },
      },
    },
  },
  watch: {
    "slider.sliderType"(value) {
      this.slider.file = null;
    },
  },
  computed: {
    ...mapState({
      sliderVideoTypes: (state, getters) => state.common.sliderVideoTypes,
    }),
    isImage() {
      return this.slider.sliderType === "1" || this.slider.sliderType === 1;
    },
  },
  created() {},
  methods: {
    cancel() {
      this.$router.push({ path: "." });
    },
    save() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        var vm = this;
        this.$services.upload("system/sliders", this.slider).done((id) => {
          vm.$toastr.s("Thêm mới slider thành công!");
          vm.$router.push({ path: "." });
        });
      }
    },
  },
};
</script>
<style scoped>
</style>
